import { combineReducers } from "redux";
import fetch from "./fetch/fetchReducers";
import fetchInspection from "./fetchInspection/fetchInspectionReducers";
import refreshInspection from "./refreshInspection/refreshInspectionReducer";
import directInspection from './refreshInspection/refreshInspectionReducer';
import refreshArrivalDepature from './refreshArrivalDepature/refreshArrivalDepatureReducers'

const rootReducer = combineReducers({
  fetch,
  fetchInspection,
  refreshInspection,
  directInspection,
  refreshArrivalDepature
});

export default rootReducer;
